export enum SpentPercentageStatusEnum {
    Low = 'low',
    High = 'high',
    Exceeded = 'exceeded',
}
